<template>
    <span class="text-warning float-left mr-1">
        <i
            class="fa fa-arrow-down fa-lg icon-button"
            title="Aplicar Deflator"
            @click.stop="abrirModal()"
        ></i>

        <b-modal
            :id="modalId"
            v-model="mostrarModal"
            @shown="aoAbrirModal"
            @hidden="reset()"
        >
            <div slot="modal-title">
                Deflator do Item -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>

            <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>

            <b-row class="mb-2">
                <b-col sm="12">
                    <small class="text-muted">
                        <b>Item:</b>
                        {{ item.ordem }} - {{ item.descricao }}
                    </small>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valorDeflator.$dirty ? !$v.valorDeflator.$invalid : null"
                        invalid-feedback="Informe um valor válido maior que zero."
                    >
                        <label class="required">Valor do Deflator</label>
                        <money
                            :key="moneyKey"
                            v-model="valorDeflator"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valorDeflator.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    class="ml-1"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvar()"
                >
                    Salvar
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import ContratosServicos from '../ContratosServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },
        item: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'ATUALIZAÇÃO',
            erros: [],
            valorDeflator: 0,
            moneyKey: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    computed: {
        
        modalId() {
            return `modalDeflatorItemContrato_${this.item.itemContratoId}`
        },
        
        desabilitarBtnSalvar() {
            return this.$v.$dirty && this.$v.$invalid
        },
    },

    watch: {
        'item.itemContratoId': function () {
            if (this.mostrarModal) {
            this.preencherForm()
            this.moneyKey++
            }
        },
        'item.saldoContratoAnterior': function () {
            if (this.mostrarModal) {
            this.preencherForm()
            this.moneyKey++
            }
        }
    },

    methods: {
        abrirModal() {
            this.reset()
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        aoAbrirModal() {
            this.preencherForm()

            this.$nextTick(() => {
                if (this.$v && this.$v.valorDeflator) {
                this.$v.valorDeflator.$touch()
                }
            })
        },

        reset() {
            this.erros = []
            this.valorDeflator = 0

            if (this.$v) {
                this.$nextTick(() => this.$v.$reset())
            }
        },

        preencherForm() {
            const atual = this.item && this.item.saldoContratoAnterior != null
                ? Number(this.item.saldoContratoAnterior)
                : 0

            this.valorDeflator = Math.abs(atual) || 0
        },

        confirmarSalvar() {
            this.$v.$touch()
            if (this.$v.$invalid) return

            this.$swal({
                title: 'Deflator do Item',
                html: `Confirma salvar o deflator do item <b>${this.item.ordem} - ${this.item.descricao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')

            const valorPositivo = Number(this.valorDeflator) || 0
            const dto = { valorDeflator: valorPositivo }

            ContratosServicos.aplicarDeflatorItemContrato(
                this.contrato.idContrato,
                this.item.itemContratoId,
                dto
            )
            .then((response) => {
                if (!response) return

                if (response.success) {
                    this.$toast.success(
                        'Deflator aplicado no Item com sucesso. Verifique se é necessário aplicar o deflator também nas Fases do Contrato',
                        'OK',
                        this.$toastConfig.success)
                    this.$emit('obterContratoAtualizado', true)
                    this.$emit('obterItensAtualizados')
                    this.mostrarModal = false
                } else {
                    this.erros = response.errors
                }
            })
            .finally(() => {
                this.$store.dispatch('removeRequest')
            })
        }
    },

    validations: {
        valorDeflator: {
            required,
            minValue: minValue(0.01)
        }
    }
}
</script>
